import { Button, cn } from '@kalos/ui';
import { type ReactNode } from 'react';

type EmptyStateProps = {
  title: string;
  description?: string;
  className?: string;
} & (
  | {
      /** Nothing exists yet. `action` is the control that changes that, if there is one. */
      variant?: 'empty';
      action?: ReactNode;
    }
  | {
      /** Records exist but the current filters hide them all. */
      variant: 'filtered';
      onClearFilters: () => void;
    }
);

/**
 * The worded state a list shows when it has no records to display.
 * Use `LoadErrorState` when the load failed; the two must never look alike.
 */
export const EmptyState = (props: EmptyStateProps) => {
  const { title, description, className } = props;

  return (
    <div
      role="status"
      className={cn('flex flex-col items-center gap-2 px-4 py-8 text-center', className)}
    >
      <p className="text-foreground text-sm font-semibold">{title}</p>
      {description && <p className="text-muted-foreground text-sm">{description}</p>}
      {props.variant === 'filtered' ? (
        <Button variant="outline" className="mt-2" onClick={props.onClearFilters}>
          Clear filters
        </Button>
      ) : (
        props.action && <div className="mt-2">{props.action}</div>
      )}
    </div>
  );
};
